import { useAuth } from '@/hooks/useAuth';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useIsAdmin() {
  const { user, loading: authLoading } = useAuth();

  const { data: isAdmin, isLoading: roleLoading } = useQuery({
    queryKey: ['user-role', user?.id],
    enabled: !!user && !authLoading,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    queryFn: async () => {
      const { data, error } = await supabase.rpc('has_role', {
        _user_id: user!.id,
        _role: 'admin'
      });

      if (error) {
        console.error('[useIsAdmin] Error checking admin role:', error);
        return false;
      }

      return Boolean(data);
    }
  });

  return {
    isAdmin: isAdmin ?? false,
    isLoading: authLoading || roleLoading
  };
}
